import { Pill, PillColor, PillSize } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';

export const NewPill = () => {
  const { getTranslation } = useTranslate();
  return (
    <Pill color={PillColor.Red} size={PillSize.Small}>
      {getTranslation('common_new')}
    </Pill>
  );
};
